module.exports = __webpack_public_path__ + "img/screen-upload-sucesso.fbef4362.png";